import { Component } from "@angular/core";

/**
 * Created by mac90082 on 10/26/16.
 */
@Component({
    selector: 'app-alerts',
    template: require('./alerts.html')
})
export class AlertsComponent {

}
